<app-breadcrumb-bar
  [previous]="previous"
  [breadcrumbs]="breadcrumbs"></app-breadcrumb-bar>
